import { CloseButtonSizeType, } from '../../../../../components/closeButton/types/closeButton';
import { getCustomStyles } from './variantStyles/custom';
import { getMainSectionStyles } from './variantStyles/mainSection';
import { getPrimaryStyles } from './variantStyles/primary';
import { getPrimaryOnSurfaceStyles } from './variantStyles/primaryOnSurface';
import { getSecondaryStyles } from './variantStyles/secondary';
import { getSecondaryFloatingStyles } from './variantStyles/secondaryFloating';
import { getSecondaryOnSurfaceStyles } from './variantStyles/secondaryOnSurface';
export const getCloseButtonStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CloseButtonSizeType.SMALL_PRIMARY]: {
            icon: {
                height: FOUNDATIONS.size_300,
                width: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
        },
        [CloseButtonSizeType.SMALL_SECONDARY]: {
            icon: {
                height: FOUNDATIONS.size_200,
                width: FOUNDATIONS.size_200,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
            containerSize: {
                padding: FOUNDATIONS.spacing_100,
            },
        },
        [CloseButtonSizeType.LARGE_PRIMARY]: {
            icon: {
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
        },
        [CloseButtonSizeType.LARGE_SECONDARY]: {
            icon: {
                height: FOUNDATIONS.size_200,
                width: FOUNDATIONS.size_200,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
            containerSize: {
                padding: FOUNDATIONS.spacing_150,
            },
        },
        ...getPrimaryStyles(FOUNDATIONS, FONT),
        ...getPrimaryOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getSecondaryStyles(FOUNDATIONS, FONT),
        ...getSecondaryOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getSecondaryFloatingStyles(FOUNDATIONS, FONT, SHADOWS),
        ...getCustomStyles(FOUNDATIONS, FONT),
        ...getMainSectionStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map